import RecordMetric from './record-metric';

export default RecordMetric;
